import React, { useEffect, useState } from "react";
import { Button } from "@material-ui/core";
import useStyles from "./styles";
import { Typography } from "../Wrappers";

export default function PageTitle(props) {
  var classes = useStyles();
  const [styles, setStyles] = useState(null);

  useEffect(() => {
    if (props.style) {
      setStyles(props.style)
    } else {
      setStyles(null);
    }
  }, []);

  return (
    <div className={classes.pageTitleContainer} style={{ ...styles, position: 'atatic', right: 420, zIndex: 999, marginTop: 50}} >
      <Typography className={classes.typo} style={{ fontSize: 35, fontFamily: 'Lilita One' }} variant="h1" size="sm">
        {props.title}
      </Typography>
      <div style={{}}>

      {props.fourthButton && (
          <Button
            classes={{ root: classes.button }}
            onClick={props.onFourthClick}
            style={{marginRight: 10}}
            variant="contained"
            size="large"
            color="secondary"
          >
            {props.fourthButton}
          </Button>
        )}

      {props.thirdButton && (
          <Button
            classes={{ root: classes.button }}
            onClick={props.onThirdClick}
            style={{marginRight: 10}}
            variant="contained"
            size="large"
            color="secondary"
          >
            {props.thirdButton}
          </Button>
        )}
      {props.secondButton && (
          <Button
            classes={{ root: classes.button }}
            onClick={props.onSecondClick}
            style={{marginRight: 10}}
            variant="contained"
            size="large"
            color="secondary"
          >
            {props.secondButton}
          </Button>
        )}
        {props.button && (
          <Button
            classes={{ root: classes.button }}
            onClick={props.onClick}
            style={{marginRight: 10}}
            variant="contained"
            size="large"
            color="secondary"
          >
            {props.button}
          </Button>
        )}

      </div>
    </div>
  );
}
